import React, { useRef, useEffect, useCallback, useState} from 'react';
import {
    mouseDown,
    setSelectedPianoRollSteps} from 'actions/index.js';
import {connect} from 'react-redux';
import StepControl from './StepControl.js';

const HEIGHT = 80;

const PianoRollController = ({
    xScale,
    pattern,
    controlParameter,
    color,
    style,
    track,
    steps,
    pianoSteps,
    resolution,
    setSelectedPianoRollSteps,
    selectedPianoRollSteps,
}) => { 
    const ref = useRef(undefined);
    const mouseDown = useRef(false);
    const controlMouseDown = useRef(false);

    let [currentVelocity, setCurrentVelocity] = useState(undefined);
    const onMouseUp = useCallback((e) => {
        setSelectedPianoRollSteps(undefined);
        mouseDown.current = false;
        controlMouseDown.current = false;
    }, []);

    const onMouseMove = useCallback((e) => {
        let keyboard = track.sequencerEngine.state.keyboard;
        let selectedPianoRollSteps = keyboard.selectedPianoRollSteps;
        if (controlMouseDown.current && selectedPianoRollSteps) {
            let value = 0;
            for (let step of selectedPianoRollSteps) {
                if (!step) { continue; }
                let rect = ref.current.getBoundingClientRect();
                let y = e.clientY - rect.top;
                let height = Math.max(1, HEIGHT - y);
                let ratio = Math.min(1, height / HEIGHT);
                let parameter = step[controlParameter + "Parameter"];
                value = parameter.min + ratio * (parameter.max - parameter.min);
                step[controlParameter] = value;
            }
            setCurrentVelocity(value);
        }
    }, [setCurrentVelocity, controlParameter]);

    if (!pianoSteps) {
        return (
            <div className="controller" style={style}/>
        );
    }
    return (
        <div
          onMouseDown={() => {
              mouseDown.current = true;
          }}
          onMouseLeave={() => {
              mouseDown.current = false;
              controlMouseDown.current = false;
          }}
          onMouseMove={onMouseMove}
          onMouseUp={onMouseUp}
          ref={ref}
          className="controller" style={style}>
          {Object.keys(pianoSteps).filter(note => pianoSteps[note])
           .map(
               note =>
                   Object.keys(pianoSteps[note]).map(
                       (stepNumber, i) =>
                           <StepControl
                             key={note + '-' + i}
                             mouseDown={mouseDown}
                             controlMouseDown={controlMouseDown}
                             controlParameter={controlParameter}
                             currentVelocity={currentVelocity}
                             selectedPianoRollSteps={selectedPianoRollSteps}
                             track={track}
                             controlRef={ref}
                             color={color}
                             pattern={pattern}
                             note={parseFloat(note)}
                             resolution={resolution}
                             xScale={xScale}
                             stepNumber={parseFloat(stepNumber)}/>))}
        </div>);
}

const mapStateToProps = (state, props) => {
    let steps = state.tracks.trackSteps[props.track.id];
    let pianoSteps = state.tracks.trackPianoRollSteps[props.track.id];
    let durations = state.tracks.trackPianoRollDurations[props.track.id];
    return {
        resolution: state.sequencer.displayResolution,
        steps: steps,
        pianoSteps,
        selectedPianoRollSteps: state.keyboard.selectedPianoRollSteps,
        pattern: props.track.getEasyPattern().pattern,
        selectedTrack: state.mix.selectedTrack
    };
};

const mapDispatchToProps = (dispatch) => {
  return {
      setSelectedPianoRollSteps: (steps) => dispatch(setSelectedPianoRollSteps(steps)),
      mouseDown: (x) => dispatch(mouseDown(x))
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(PianoRollController);
